<template>
  <b-container>
    <Faq :title="title" :custom-faq="customFaq" />
  </b-container>
</template>

<script>
import Faq from '@/components/Common/Faq';
export default {
  components: {
    Faq
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['slice'],
  data() {
    return {
      customFaq: [],
      title: []
    };
  },
  created() {
    const columns = this.slice.items;
    this.title = this.slice.primary.title1[0]?.text ? this.slice.primary.title1 : [];
    this.customFaq = columns
      .filter((el) => el.question[0]?.text && el.answer[0]?.text)
      .map((el) => {
        return {
          ...el,
          question: el.question[0]?.text,
          answer: el.answer
        };
      });
  }
};
</script>

<style lang="scss" scoped></style>
